export const MAX_DEPOSIT_ORDER_CAPACITY = 1_000_000;
export const DEPOSIT_ORDER_CAPACITY_ERROR = 'Объём ордера пополнения должен быть целым числом от 1 до 1 000 000';
export const isValidDepositOrderCapacity = (amount: number): boolean =>
    Number.isInteger(amount) && amount >= 1 && amount <= MAX_DEPOSIT_ORDER_CAPACITY;
